<template>
  <div>
    <el-dialog
      append-to-body
      visible
      title="Sửa thông tin đặt phòng"
      :close-on-click-modal="false"
      width="1200px"
      @close="onClose"
    >
      <BookingRoomForm
        ref="BookingRoomForm"
        :action="statusBooking == 1 ? 'edit' : 'edit-checked-in'"
        :record-data="bookingDetailStore"
      />

      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="fnUpdateRoomBooking">
          Cập nhật
        </button>
        <button class="btn primary small outline" @click="onClose">Đóng</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditRoomBookingDailyPriceTable from './EditRoomBookingDailyPriceTable'
import BookingRoomForm from '@/components/resources/booking/BookingRoomForm.vue'
import { updateRoomBookingApi } from '@/api/chamber_service/common'
import { notifyError, notifySuccess } from '@/utils/toast'
// STORE
import { bookingDetailStore, roomInfo } from '../stores/'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EditRoomBookingDailyPriceTable,
    BookingRoomForm
  },
  props: {
    statusBooking: {
      type: Number
    }
  },
  data() {
    return {
      bookingDetailStore,
      newVersion: true,
      dialogLoading: false,
      roomBookingForm: {},
      roomInfo,

      // SELECT OPTIONS
      roomLevelOptionsCol: [
        {
          headerName: 'Tên',
          field: 'room_level_name',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng',
          field: 'total_room',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng trống',
          field: 'room_available_num',
          // cellClass: "grid-cell-centered",
          flex: 3
        }
      ],
      hotelOptions: [],
      currencyOptions: []
    }
  },
  computed: {},
  methods: {
    onClose() {
      this.$emit('close')
    },

    fnUpdateRoomBooking() {
      const payload = this.$refs.BookingRoomForm.dehydrateForm()
      updateRoomBookingApi(roomInfo.sub_booking_group_id, payload)
        .then(res => {
          notifySuccess(res?.message)
          this.onClose()
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
        })
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
hr {
  border-top: 1px solid #dedfe7;
  width: 100%;
}
</style>
